var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEcommercePlan(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.001,
    height: 48,
    viewBox: "0 0 48.001 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2571",
    "data-name": "Group 2571",
    transform: "translate(-1468 -340)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7347",
    "data-name": "Path 7347",
    d: "M33.162,10.868a.9.9,0,0,1-.885-.728L30.616,1.811H26.839a.906.906,0,0,1,0-1.811h4.517a.9.9,0,0,1,.886.728l1.937,9.706c.1.49-.349.318-.838.416a.887.887,0,0,1-.178.018",
    transform: "translate(1447.937 340)",
    fill: "#00feff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7348",
    "data-name": "Path 7348",
    d: "M83.226,190.7a2.71,2.71,0,1,1-2.711-2.719,2.713,2.713,0,0,1,2.711,2.719",
    transform: "translate(1407.811 194.579)",
    fill: "#9734eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7349",
    "data-name": "Path 7349",
    d: "M172.9,190.717A2.71,2.71,0,1,1,170.19,188a2.715,2.715,0,0,1,2.711,2.717",
    transform: "translate(1338.439 194.566)",
    fill: "#9734eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7350",
    "data-name": "Path 7350",
    d: "M171.9,68.575h3.419a1,1,0,0,1,.011-.14l3.826-24.276-4.7.02c0,.014,0,.025,0,.038Z",
    transform: "translate(1335.021 305.84)",
    fill: "#00feff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7351",
    "data-name": "Path 7351",
    d: "M195.042,68.451h0L198.882,44v.027c0,.036-.007.077-.012.115Z",
    transform: "translate(1317.119 305.964)",
    fill: "#00feff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7352",
    "data-name": "Path 7352",
    d: "M152.859,68.667c0-.032,0-.063,0-.1l2.552-24.294-5.791.025V68.667Z",
    transform: "translate(1352.252 305.747)",
    fill: "#00feff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7353",
    "data-name": "Path 7353",
    d: "M91.228,68.884h3.419L92.091,44.558l-4.68.02,3.806,24.165a1,1,0,0,1,.011.14",
    transform: "translate(1400.381 305.531)",
    fill: "#00feff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7354",
    "data-name": "Path 7354",
    d: "M118.649,68.776h3.234V44.418l-5.784.025,2.545,24.238c0,.032,0,.063,0,.1",
    transform: "translate(1378.188 305.639)",
    fill: "#00feff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7355",
    "data-name": "Path 7355",
    d: "M53.944,44.7l5.4,24.274H63.52l-3.828-24.3Z",
    transform: "translate(1426.27 305.438)",
    fill: "#00feff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7356",
    "data-name": "Path 7356",
    d: "M98.175,156.526H69.824c1.516-1.519,2.153-2.977,1.807-4.528H98.175s-.9,4.528,0,4.528",
    transform: "translate(1413.984 222.417)",
    fill: "#9734eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1052",
    "data-name": "Rectangle 1052",
    width: 1.807,
    transform: "translate(1500.07 374.415)",
    fill: "#01016c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7357",
    "data-name": "Path 7357",
    d: "M143.452,68.753V44.388l-1.807.007V68.753Z",
    transform: "translate(1358.426 305.662)",
    fill: "#0f0fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1053",
    "data-name": "Rectangle 1053",
    width: 1.82,
    transform: "translate(1510.34 374.415)",
    fill: "#01016c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7358",
    "data-name": "Path 7358",
    d: "M187,68.544h1.82l3.828-24.31c0-.038.009-.079.012-.115l-1.823.009L187.013,68.4a1,1,0,0,0-.011.14",
    transform: "translate(1323.338 305.871)",
    fill: "#00feff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1054",
    "data-name": "Rectangle 1054",
    width: 1.809,
    transform: "translate(1505.111 374.415)",
    fill: "#01016c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7359",
    "data-name": "Path 7359",
    d: "M163.91,68.644h1.809l2.559-24.358c0-.014,0-.025,0-.038l-1.813.007-2.552,24.294c0,.032,0,.063,0,.1",
    transform: "translate(1341.201 305.771)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1055",
    "data-name": "Rectangle 1055",
    width: 1.818,
    transform: "translate(1489.79 374.415)",
    fill: "#9734eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7360",
    "data-name": "Path 7360",
    d: "M84.966,68.813,81.16,44.648l-1.829.007,3.828,24.3h1.818a1,1,0,0,0-.011-.14",
    transform: "translate(1406.631 305.461)",
    fill: "#9734eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1056",
    "data-name": "Rectangle 1056",
    width: 1.809,
    transform: "translate(1495.027 374.415)",
    fill: "#01016c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7361",
    "data-name": "Path 7361",
    d: "M112.445,68.861c0-.032,0-.063,0-.1l-2.545-24.238-1.816.007,2.557,24.326Z",
    transform: "translate(1384.393 305.554)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7362",
    "data-name": "Path 7362",
    d: "M20.665,105.811H18.858a.906.906,0,0,1,0-1.811h1.807a.906.906,0,0,1,0,1.811",
    transform: "translate(1454.11 259.547)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7363",
    "data-name": "Path 7363",
    d: "M40.24,73.811h-5.42a.906.906,0,0,1,0-1.811h5.42a.906.906,0,0,1,0,1.811",
    transform: "translate(1441.763 284.302)",
    fill: "#0f0fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7364",
    "data-name": "Path 7364",
    d: "M27.894,89.811H10.879a.906.906,0,0,1,0-1.811H27.894a.906.906,0,0,1,0,1.811",
    transform: "translate(1460.283 271.924)",
    fill: "#9734eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7365",
    "data-name": "Path 7365",
    d: "M2,104.906A.9.9,0,1,0,2.9,104a.9.9,0,0,0-.9.906",
    transform: "translate(1466.457 259.547)",
    fill: "#00feff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7366",
    "data-name": "Path 7366",
    d: "M17.955,72.906a.9.9,0,1,0,.9-.906.9.9,0,0,0-.9.906",
    transform: "translate(1454.11 284.302)",
    fill: "#9734eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7367",
    "data-name": "Path 7367",
    d: "M35.722,41.811h-.9a.906.906,0,0,1,0-1.811h.9a.906.906,0,0,1,0,1.811",
    transform: "translate(1441.764 309.057)",
    fill: "#9734eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7368",
    "data-name": "Path 7368",
    d: "M13.752,57.811H.9A.906.906,0,0,1,.9,56H13.752a.906.906,0,0,1,0,1.811",
    transform: "translate(1468 296.679)",
    fill: "#00feff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1057",
    "data-name": "Rectangle 1057",
    width: 48,
    height: 48,
    transform: "translate(1468 340)",
    fill: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEcommercePlan);
export default __webpack_public_path__ + "static/media/ecommerce-plan.71b8aa0bdf1a8561a5d754df120dbf6d.svg";
export { ForwardRef as ReactComponent };